import enumeration from "./enumeration";

const PreAuthStatus = {
  PENDING: "PENDING",
  PENDING_COMPLETE: "PENDING_COMPLETE",
  Completed: "COMPLETED",
  Void: "VOID",
};

export default enumeration(PreAuthStatus);
